import {environmentConfig} from "@/config/enviromentConfig";
import axios from "axios";

const headers = {Authorization: `Basic ${environmentConfig.authHeader}`};

export default class DepService {
    static async requestOtp(msisdn, productId) {
        return await axios.post(`${environmentConfig.depService}/request-otp`, {
                msisdn: msisdn,
                productId: productId,
            },
        )
    }

    static async validateOtp(msisdn, productId, otp) {
        return await axios.post(`${environmentConfig.depService}/validate-otp`, {
                msisdn: msisdn,
                productId,
                otp: otp,
            },
        )
    }

    static async getUserViaProductId(msisdn, productId) {
        try {
            return await axios.post(`${environmentConfig.depService}/get-user-via-msisdn`, {
                    msisdn,
                    productId: productId,
                },
            )
        } catch (e) {
            return {authError: true};
        }
    }

    static async decryptMsisdn(encryptedMsisdn) {
        return await axios.post(`${environmentConfig.depService}/decrypt-msisdn/v2`, {
                encryptedMsisdn,
            }, {headers}
        )
    }

    static async encryptUserMsisdn(msisdn) {
        return await axios.post(`${environmentConfig.depService}/encrypt-msisdn/v2`, {
                msisdn: msisdn,
            }, {headers}
        )
    }
}